import React, { useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authService } from '../../services/api';

export default function ResetPassword() {
  const { t } = useTranslation('auth');
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => params.get('token') || '', [params]);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setMsg(t('passwordsMismatch'));
      return;
    }
    setLoading(true);
    setMsg('');
    try {
      const { data } = await authService.confirmPasswordReset({ token, new_password: password });
      setMsg(data.message || t('resetSuccess'));
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setMsg(t('resetError'));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4 bg-slate-950">
        <div className="text-center space-y-2 text-white">
          <p>{t('invalidLink')}</p>
          <Link to="/forgot-password" className="text-primary-300 hover:underline">
            {t('requestNewLink')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white/[0.97] shadow-strong p-8 space-y-4">
        <h1 className="text-xl font-bold text-gray-900">{t('newPassword')}</h1>
        <form onSubmit={submit} className="space-y-3">
          <input
            className="form-input w-full"
            type="password"
            required
            minLength={8}
            placeholder={t('newPassword')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <input
            className="form-input w-full"
            type="password"
            required
            minLength={8}
            placeholder={t('confirmPassword')}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
          <button type="submit" disabled={loading} className="btn btn-primary w-full">
            {loading ? t('common:saving') : t('resetAction')}
          </button>
        </form>
        {msg && <p className="text-sm text-gray-700">{msg}</p>}
      </div>
    </div>
  );
}
